import { addReducer } from '../../redux/modules/root';
import { IAccountAction, IAccountState, IRootAccountState } from '../models';
import { accountRegistry } from '../redux';

addReducer<IRootAccountState, IAccountState, IAccountAction>('account', accountRegistry);
